"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = exports.AuthConsumer = void 0;
var _conversionService = _interopRequireDefault(require("api/conversionService"));
var _loader = _interopRequireDefault(require("components/common/loader"));
var _reactRouter = require("react-router");
var _unauth = _interopRequireDefault(require("components/common/unauth"));
var _axios = _interopRequireDefault(require("axios"));
var _getters = _interopRequireDefault(require("components/analytics/getters"));
var _uuid = _interopRequireDefault(require("uuid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } // import AuthContext from './authContext'
var AuthContext = React.createContext();
var AuthProvider = exports.AuthProvider = /*#__PURE__*/function (_React$Component) {
  function AuthProvider(props) {
    var _this;
    _classCallCheck(this, AuthProvider);
    _this = _callSuper(this, AuthProvider, [props]);
    _this.state = {
      isAuth: false,
      userId: '',
      groups: ''
    };
    _this._isValidCall = false;
    return _this;
  }
  _inherits(AuthProvider, _React$Component);
  return _createClass(AuthProvider, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      _axios["default"].interceptors.request.use(function (config) {
        config.headers = {
          'Trv-Correlation-Id': _uuid["default"].v4(),
          'Trv-Session-Id': _getters["default"].sessionId
        };
        return config;
      }, function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var accessObject = JSON.parse(window.sessionStorage.getItem('okta-token-storage'));
      if (accessObject && accessObject.accessToken) {
        var _accessObject$accessT, _accessObject$accessT2;
        var userId = accessObject === null || accessObject === void 0 || (_accessObject$accessT = accessObject.accessToken) === null || _accessObject$accessT === void 0 || (_accessObject$accessT = _accessObject$accessT.claims) === null || _accessObject$accessT === void 0 ? void 0 : _accessObject$accessT.sub;
        var groups = accessObject !== null && accessObject !== void 0 && (_accessObject$accessT2 = accessObject.accessToken) !== null && _accessObject$accessT2 !== void 0 && (_accessObject$accessT2 = _accessObject$accessT2.claims) !== null && _accessObject$accessT2 !== void 0 && _accessObject$accessT2.groups ? accessObject.accessToken.claims.groups[0] : '';
        this.setState({
          userId: userId,
          groups: groups.toUpperCase(),
          isAuth: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isAuthenticated = this.state.isAuth;
      return /*#__PURE__*/React.createElement(AuthContext.Provider, {
        value: {
          isAuth: this.state.isAuth,
          userId: this.state.userId,
          groups: this.state.groups
        }
      }, this.props.children);
    }
  }]);
}(React.Component);
var AuthConsumer = exports.AuthConsumer = AuthContext.Consumer;